import { render, staticRenderFns } from "./AdminCrowdin.vue?vue&type=template&id=07e67ec6&scoped=true"
import script from "./AdminCrowdin.vue?vue&type=script&lang=js"
export * from "./AdminCrowdin.vue?vue&type=script&lang=js"
import style0 from "./AdminCrowdin.vue?vue&type=style&index=0&id=07e67ec6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e67ec6",
  null
  
)

export default component.exports